import React, { createContext, useContext, useState } from "react";

const LoginOverlayContext = createContext();

export const useLoginOverlay = () => {
  const context = useContext(LoginOverlayContext);
  if (!context) {
    throw new Error(
      "useLoginOverlay must be used within a LoginOverlayProvider",
    );
  }
  return context;
};

export const LoginOverlayProvider = ({ children }) => {
  const [showLoginSheet, setShowLoginSheet] = useState(false);

  return (
    <LoginOverlayContext.Provider
      value={{
        showLoginSheet,
        setShowLoginSheet,
      }}
    >
      {children}
    </LoginOverlayContext.Provider>
  );
};
